import { ROUTE_BUSINESS_PROFILES, ROUTE_CUSTOMERS, ROUTE_MODERATE_BUSINESS_PROFILES } from '@@partner:config/routes'
import { usePartner } from '@@partner:helpers/hooks/auth'
import React from 'react'
import {  PeopleCircle, PeopleOutline, StarOutline } from 'react-ionicons'
import { generatePath, NavLink } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'
import CheckSquareO from '@rsuite/icons/legacy/CheckSquareO'
import PeopleGroup from '@rsuite/icons/legacy/PeopleGroup'


export default function CustomersTopMenu () {
  const { brandSlug } = usePartner()

  return (
    <Navbar>
      <Nav>
        <Nav.Item
          icon={<PeopleCircle />}
          as={NavLink}
          to={generatePath(ROUTE_CUSTOMERS, { brandSlug })}
        >
          Физические лица
        </Nav.Item>
        <Nav.Item
          icon={<PeopleGroup />}
          as={NavLink}
          to={generatePath(ROUTE_BUSINESS_PROFILES, { brandSlug })}
        >
          Компании
        </Nav.Item>
        <Nav.Item
          icon={<CheckSquareO />}
          as={NavLink}
          to={generatePath(ROUTE_MODERATE_BUSINESS_PROFILES, { brandSlug })}
        >
          Модерация компаний
        </Nav.Item>
      </Nav>
    </Navbar>
  )
}